__turbopack_context__.v({
  "drawer-buttons": "PropositionCard-module-scss-module__0KgxEq__drawer-buttons",
  "header": "PropositionCard-module-scss-module__0KgxEq__header",
  "icon": "PropositionCard-module-scss-module__0KgxEq__icon",
  "price": "PropositionCard-module-scss-module__0KgxEq__price",
  "product": "PropositionCard-module-scss-module__0KgxEq__product",
  "proposition": "PropositionCard-module-scss-module__0KgxEq__proposition",
  "shape": "PropositionCard-module-scss-module__0KgxEq__shape",
  "submit": "PropositionCard-module-scss-module__0KgxEq__submit",
  "tag": "PropositionCard-module-scss-module__0KgxEq__tag",
});
